module.exports = __webpack_public_path__ + "static/media/alfredo.7710753d.png";